// extracted by mini-css-extract-plugin
export default {"orWrapper":"KeyboardShortcutsModal-module__orWrapper--cHSVB"};